export enum OrderContactType {
  Individual = 1,
  Corporation = 2,
  Trust = 3,
  LLC = 4,
}
